import { render, staticRenderFns } from "./SchoolApply.vue?vue&type=template&id=722d973d&scoped=true"
import script from "./SchoolApply.vue?vue&type=script&lang=js"
export * from "./SchoolApply.vue?vue&type=script&lang=js"
import style0 from "./SchoolApply.vue?vue&type=style&index=0&id=722d973d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722d973d",
  null
  
)

export default component.exports